import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./styles/index.css";

// Dev-only Pronto primitives gallery (Phase 1). Reachable at #pronto-preview so
// the redesign foundation can be validated in isolation without disturbing the
// live app. Code-split so it never ships in the normal bundle graph.
const ProntoPreview = lazy(() =>
  import("./components/ProntoPreview.jsx").then((m) => ({ default: m.ProntoPreview }))
);
const isPreview = window.location.hash === "#pronto-preview";

// Theme: URL ?theme override (for testing/sharing) → saved choice → system.
(function initTheme() {
  try {
    const urlTheme = new URLSearchParams(window.location.search).get("theme");
    const saved = localStorage.getItem("pronto-theme");
    const prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    const theme = urlTheme || saved || (prefersDark ? "dark" : "light");
    document.documentElement.dataset.theme = theme;
  } catch {
    document.documentElement.dataset.theme = "light";
  }
})();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {isPreview ? (
      <Suspense fallback={null}>
        <ProntoPreview />
      </Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// Register the push service worker (no-op where unsupported). Subscription +
// permission are requested later from a tap in Settings, never on load.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((e) => {
      console.warn("SW registration failed:", e?.message);
    });
  });
}
